import { DefaultBankAccountRequest } from 'vopay';
import apiConfig from '@/services/api.config';

const { api } = apiConfig;

export default function useDefaultBankAccount() {
  async function fetchDefaultBankAccount(req: DefaultBankAccountRequest) {
    try {
      const res = await api.fetchDefaultBankAccount(req);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return Object.values(res.DefaultOperationalBankAccount || {}).find((x) => x.IsDefault);
    } catch (err) {
      console.error(err);
    }
  }

  return fetchDefaultBankAccount;
}
